// extracted by mini-css-extract-plugin
export var cancelButton = "_mw-5";
export var content = "_mw-3";
export var createButton = "_mw-6";
export var drawerContainer = "_mw-0";
export var footer = "_mw-2";
export var header = "_mw-1";
export var orderFormColumn = "_mw-4";